module.exports = __webpack_public_path__ + "media/images/common/back_btn_l_ov-ca244a5f10f2e34c2e349d44ef665c2c.png";